/** Messages d'erreur montrés à l'utilisateur. */
import { ErreurDonnees, ErreurValidation } from '../../supabase/depot';

export function messageErreur(e: unknown): string {
  if (e instanceof ErreurValidation) return e.erreurs.join(' ');
  if (e instanceof ErreurDonnees) {
    if (e.code === '40001')
      return 'La carte a été revue sur un autre appareil : la séance reprend avec son état à jour.';
    if (e.code === '23514' || e.code === 'P0002') return e.message;
    if (e.code === '42501') return 'Votre session a expiré. Reconnectez-vous.';
  }
  if (e instanceof TypeError || (e instanceof Error && /fetch|network/i.test(e.message))) {
    return 'Connexion perdue : l’action n’a pas été enregistrée. Réessayez.';
  }
  return e instanceof Error && e.message ? e.message : 'Une erreur est survenue. Réessayez.';
}
